import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DataTransferService } from '../../../../services/DataTransferService';
@Component({
  selector: 'receipts-product-group',
  templateUrl: './product-group.component.html',
  styleUrls: ['./product-group.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class ProductGroupComponent implements OnInit, OnChanges, AfterViewInit
{
  productGroup;
  ngAfterViewInit(): void {
    this.data.currentProductGroupSource.subscribe(x => this.productGroup = x);
    if (this.productGroup != "default message" && this.productGroup != null) {
      this.selectProductGroup(this.productGroup)
    }
  }
  @Output() productGroupObject = new EventEmitter();
  @Input() changing: boolean;
  @Input() enableChange;
  isOpen: boolean = true;
  selectedProductGroup: string;
  @Output() isEnableSelectProductType = new EventEmitter();
  @Output() isEnableSelectCountry = new EventEmitter();
  @Output() isEnableSelectCity = new EventEmitter();
  
  ngOnChanges(changes: SimpleChanges) {
    
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true)
        this.isOpen = change;
      console.log('changing in product-group', change);
    }
  }
  constructor(private data: DataTransferService) {
  }

  selectProductGroup(ProductGroupName,isClose?) {
    this.selectedProductGroup = ProductGroupName;
    this.isEnableSelectProductType.emit(true);
    this.isEnableSelectCountry.emit(true);
    this.productGroupObject.emit(ProductGroupName)
    this.isOpen = isClose ? !isClose : !this.isOpen;
  }
  change() {
    this.isEnableSelectProductType.emit(false);
    this.isEnableSelectCountry.emit(false);
    // make city null when change productGroup because it filled from DOM
    this.isEnableSelectCity.emit(false);
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
  }

}
